export default "__VITE_ASSET__18nBGZ19__"